var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaKnee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_3345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_3345)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.4857,
    cy: 19.2001,
    rx: 5.48571,
    ry: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685715,
    transform: "matrix(-0.374607 0.927184 0.927184 0.374607 37.0283 17.8286)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.309017 0.951057 0.951056 -0.309017 36.3428 15.4287)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685715,
    transform: "matrix(-0.766045 -0.642787 0.642788 -0.766044 35.6572 14.3999)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7456 14.4887L16.7186 7.94866C16.5784 7.87824 16.4159 7.86642 16.2669 7.9158C16.1179 7.96518 15.9947 8.07172 15.9242 8.21198C15.8538 8.35224 15.842 8.51474 15.8914 8.66371C15.9408 8.81269 16.0473 8.93595 16.1876 9.00638L29.2145 15.5465C30.3644 16.1296 31.3726 16.9578 32.168 17.9726C32.9971 19.0414 33.438 20.1767 33.4439 21.2581L31.9645 39.4767C31.9583 39.5542 31.9673 39.6321 31.9912 39.7061C32.015 39.7801 32.0532 39.8486 32.1036 39.9078C32.1539 39.967 32.2154 40.0157 32.2846 40.0512C32.3538 40.0866 32.4293 40.1081 32.5067 40.1143H32.5548C32.7039 40.1148 32.8476 40.059 32.9573 39.9581C33.067 39.8571 33.1346 39.7185 33.1465 39.5699L34.6258 21.3269V21.2788C34.6273 18.298 32.0969 15.67 29.7456 14.4887Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4737 30.1606C22.4929 28.0193 22.9101 26.7841 22.9138 26.773C22.9445 26.6855 22.9541 26.592 22.942 26.5001C22.9299 26.4082 22.8964 26.3204 22.8442 26.2438C22.7919 26.1672 22.7224 26.104 22.6412 26.0592C22.56 26.0144 22.4695 25.9893 22.3768 25.986C19.2192 25.872 14.8042 25.3203 11.7035 23.3372C9.89207 22.1789 9.37875 21.0583 9.36617 21.0302C9.30556 20.8855 9.18991 20.7707 9.04468 20.7112C8.89945 20.6517 8.73652 20.6523 8.59175 20.7129C8.44697 20.7735 8.33221 20.8892 8.2727 21.0344C8.21319 21.1796 8.21382 21.3426 8.27443 21.4873C8.36097 21.6974 10.4875 26.5303 21.5957 27.1354C21.2207 28.8588 20.6845 33.404 23.3554 39.6867C23.3858 39.7582 23.43 39.8231 23.4855 39.8776C23.5409 39.932 23.6066 39.975 23.6786 40.0041C23.7507 40.0332 23.8278 40.0478 23.9056 40.0471C23.9833 40.0464 24.0601 40.0304 24.1317 39.9999C24.2032 39.9695 24.268 39.9254 24.3225 39.8699C24.377 39.8144 24.42 39.7488 24.4491 39.6767C24.4781 39.6046 24.4927 39.5275 24.492 39.4498C24.4913 39.372 24.4753 39.2952 24.4449 39.2237C22.7836 35.316 22.456 32.1385 22.4737 30.1606Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.367 22.8195C28.2375 22.662 26.6842 21.9601 25.7507 20.7344C24.3077 18.8409 24.7892 16.2661 24.7966 16.2225C24.8275 16.0686 24.796 15.9087 24.709 15.7781C24.622 15.6474 24.4867 15.5566 24.3328 15.5257C24.1789 15.4948 24.019 15.5263 23.8884 15.6133C23.7577 15.7003 23.6669 15.8356 23.636 15.9895C23.6109 16.116 23.034 19.1087 24.8017 21.4393C25.949 22.9527 27.7922 23.8129 30.2797 23.9978C30.2945 23.9978 30.3093 23.9978 30.3241 23.9978C30.481 24.0035 30.6338 23.9466 30.7488 23.8397C30.8637 23.7327 30.9315 23.5845 30.9372 23.4275C30.9429 23.2706 30.886 23.1178 30.7791 23.0028C30.6721 22.8879 30.5239 22.8201 30.367 22.8144V22.8195Z",
    fill: "#536479"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaKnee);
export default __webpack_public_path__ + "static/media/ja_knee.06ff4f0bf7b950e423af77f5d89a7ca6.svg";
export { ForwardRef as ReactComponent };